
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { SurveyView } from '../../../backend/backendapi';
import SelectModal from '../../../selectmodal/selectmodal.controller';
import { getLocalizedSurveyNameFromSurvey } from '../../utils';

@Component({
  components: {
    SelectModal: require('../../../selectmodal/selectmodal.vue.html').default,
  },
})
export default class SurveySelectModal extends Vue {
  @Prop({ required: true })
  readonly allSurveys!: SurveyView[];

  private selectedSurveys: SurveyView[] = [];

  getLocalizedSurveyNameFromSurvey = getLocalizedSurveyNameFromSurvey;

  public open(): void {
    this.selectedSurveys.splice(0);
    (this.$refs.selectModal as SelectModal<SurveyView>).open();
  }

  public dismiss(): void {
    (this.$refs.selectModal as SelectModal<SurveyView>).dismiss();
  }

  onAddSurvey(entry: SurveyView): void {
    this.selectedSurveys.push(entry);
  }

  onRemoveSurvey(entry: SurveyView): void {
    const index = this.selectedSurveys.findIndex(e => e.id === entry.id);
    if (index >= 0) {
      this.selectedSurveys.splice(index, 1);
    }
  }
}
